import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'webmodule-order-panel',
  templateUrl: './panel.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslatePipe],
  standalone: true,
})
export class PanelComponent {
  // TODO: make required / signals with anguler@16
  @Input() canCollapse = false;
  @Input() showContent = true;
  @Output() showContentChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggleContent() {
    this.showContent = !this.showContent;

    this.showContentChange.emit(this.showContent);
  }
}
